import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import styles from "../css/media.module.css";
import SAstyles from "../css/starAttractions.module.css";

import StarAttractionCard from "../components/starAttractionsCard";
import Navbar from "../components/navbar";
// import { StarAttractions } from ".";

export default function StarAttractions() {
  const [StarAttractionItems, setStarAttractionItems] = useState([]);

  useEffect(() => {
    let StarAttractionItemsArray = [];
    getDocs(collection(db, "starAttractions")).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let StarAttractionItem = {
          id: doc.id,
          // artLink: doc.data().articleLink,
          // data: doc.data().data,
          desc: doc.data().desc,
          contentLink: doc.data().contentLink,
          title: doc.data().title,
          insta: doc.data().insta,
        };
        StarAttractionItemsArray.push(StarAttractionItem);
      });
      setStarAttractionItems(StarAttractionItemsArray);
    });
  }, []);

  return (
    <>
      <Navbar />
      <div className={SAstyles.backgroundimageStarAttractions}></div>
      <div className={styles.media}>
        <ul>
          {StarAttractionItems.map((StarAttractionItem, index) => {
            return (
              <StarAttractionCard
                starAttractionItem={StarAttractionItem}
                key={index}
              />
            );
          })}
        </ul>
      </div>
    </>
  );
}
